import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductFeatures } from './components/ProductFeatures';
import { WhyUnique } from './components/WhyUnique';
import { Achievements } from './components/Achievements';
import { CategoriesSection } from './components/CategoriesSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2805738076485440');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2805738076485440&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-[#f5a623] selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <ProductFeatures data-id="element-3" />
      <WhyUnique data-id="element-4" />
      <Achievements data-id="element-5" />
      <CategoriesSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <Guarantee data-id="element-9" />
      <Testimonials data-id="element-10" />
      <FAQ data-id="element-11" />
      <Footer data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
    </div>;
}